export class AddressEditModel {
  retrievalLocationId: number;
  address1?: string;
  address2?: string;
  addressCity?: string;
  addressState?: string;
  addressZip?: string;
  phone?: string;
  email?: string;
  faxNumber?: string;
  contactName?: string;
  nextCallDate?: string;
  nextCallDateTime?: string;
  groupName?: string;
  vendorId?: number;
  providerAgingEnabled?: boolean;

  constructor(options: {
    retrievalLocationId: number;
    address1?: string;
    address2?: string;
    addressCity?: string;
    addressState?: string;
    addressZip?: string;
    phone?: string;
    email?: string;
    faxNumber?: string;
    contactName?: string;
    nextCallDate?: string;
    nextCallDateTime?: string;
    groupName?: string;
    vendorId?: number;
    providerAgingEnabled?: boolean;
  }) {
    this.retrievalLocationId = options.retrievalLocationId;
    this.address1 = options.address1 || "";
    this.address2 = options.address2 || "";
    this.addressCity = options.addressCity || "";
    this.addressState = options.addressState || "";
    this.addressZip = options.addressZip || "";
    this.email = options.email || "";
    this.phone = options.phone || "";
    this.faxNumber = options.faxNumber || "";
    this.contactName = options.contactName || "";
    this.nextCallDate = options.nextCallDate || "";
    this.nextCallDateTime = options.nextCallDateTime;
    this.groupName = options.groupName;
    this.vendorId = options.vendorId;
    this.providerAgingEnabled = options.providerAgingEnabled;
  }
}
